import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getAllBlogCategory } from "../../redux/actions/indexActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

const AddOnlineBook = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    url: "",
    offer:"",
    discount:"",
    status: 1,
    logo: "",
  });
  const [errors, setErrors] = useState({});
  const {
    AuthReducer: { auth }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "logo") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleSubmit = () => {
    const form = new FormData();
    form.append('name', formData.name);
    form.append('discount', formData.discount);
    form.append('offer', formData.offer);
    form.append('url', formData.url);
    form.append('description', formData.description);
    form.append('logo', formData.logo);
    form.append('status', formData.status);
    axios
      .post(`/api/admin/v1/add-online-booking`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };

console.log(formData ,'errors')
  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Add Online Booking</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.name)}
                value={formData?.name}
                name="name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>URL <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.url)}
                value={formData?.url}
                name="url"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.url} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Offer <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.offer)}
                value={formData?.offer}
                name="offer"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.offer} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Discount <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.discount)}
                value={formData?.discount}
                name="discount"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.discount} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>logo</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.logo)}
                name="logo"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.logo}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Description <span className="text-danger fs-4">*</span></Label>
              <Input
                type="textarea"
                invalid={Boolean(errors?.description)}
                value={formData?.description}
                name="description"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.description} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOnlineBook;
